import { GenIcon } from '../helpers/IconBase.es.js';

const DocumentOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 25 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0074 3.5C14.1767 3.5 14.3431 3.52863 14.5 3.58321V7C14.5 7.9665 15.2835 8.75 16.25 8.75H19.6668C19.7214 8.90695 19.75 9.07332 19.75 9.24264V19C19.75 19.8284 19.0784 20.5 18.25 20.5H6.25C5.42157 20.5 4.75 19.8284 4.75 19V5C4.75 4.17157 5.42157 3.5 6.25 3.5H14.0074ZM16.25 7.25H18.3787L16 4.87132V7C16 7.13807 16.1119 7.25 16.25 7.25ZM6.25 22H18.25C19.9069 22 21.25 20.6569 21.25 19V9.24264C21.25 8.44699 20.9339 7.68393 20.3713 7.12132L16.1287 2.87868C15.5661 2.31607 14.803 2 14.0074 2H6.25C4.59315 2 3.25 3.34315 3.25 5V19C3.25 20.6569 4.59315 22 6.25 22ZM7.25 8.25C6.83579 8.25 6.5 8.58579 6.5 9C6.5 9.41421 6.83579 9.75 7.25 9.75H11.25C11.6642 9.75 12 9.41421 12 9C12 8.58579 11.6642 8.25 11.25 8.25H7.25ZM6.5 12C6.5 11.5858 6.83579 11.25 7.25 11.25H17.25C17.6642 11.25 18 11.5858 18 12C18 12.4142 17.6642 12.75 17.25 12.75H7.25C6.83579 12.75 6.5 12.4142 6.5 12ZM7.25 14.25C6.83579 14.25 6.5 14.5858 6.5 15C6.5 15.4142 6.83579 15.75 7.25 15.75H17.25C17.6642 15.75 18 15.4142 18 15C18 14.5858 17.6642 14.25 17.25 14.25H7.25Z",
          fill: "#434657"
        }
      }
    ]
  })(props);
};

export { DocumentOutlined };
